import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const AccessDenied: React.FC = () => {

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      textAlign="center"
      px={2}
    >
      <LockOutlinedIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        You do not have permission to view this page.
      </Typography>
      {/* <Button variant="contained" color="primary" onClick={() => navigate('/dashboard')}>
        Go to Home
      </Button> */}
    </Box>
  );
};

export default AccessDenied;
